// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M12.3753 5.17246L10.672 4.12427L5.20996 13H11.21L7.62377 18.8276L9.32709 19.8758L14.7891 11H8.78909L12.3753 5.17246Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M0 5H8.37178L2.52561 14.5H8.52561L5.7564 19H0V5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M21 19H11.6273L17.4734 9.50002H11.4734L14.2427 5H21V19Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M24 9V15H22V9H24Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-battery-charging-filled')
export default class BatteryChargingFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'battery-charging-filled',
    }
  }
}
